"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegisterRequestType = void 0;
var RegisterRequestType;
(function (RegisterRequestType) {
    RegisterRequestType[RegisterRequestType["ORGANIZATION"] = 1] = "ORGANIZATION";
    RegisterRequestType[RegisterRequestType["CLIENT_WITH_NO_ORGANIZATION"] = 2] = "CLIENT_WITH_NO_ORGANIZATION";
})(RegisterRequestType = exports.RegisterRequestType || (exports.RegisterRequestType = {}));
//# sourceMappingURL=RegisterRequestType.js.map